

import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import Tooltip from "@/components/common/Tooltip.vue";

@Component({
    components: {
        CircleWithInitials,
        SchedulerItemAvatar,
        Tooltip
    },
})
export default class ProjectItem extends Vue {
    @Prop({ type: Object, default: null }) readonly item!: any;
    @Prop({ type: Boolean, default: null }) readonly isOpened!: boolean;
    @Prop({ type: String, default: null }) readonly filterBy!: string;
    @Prop({ type: Boolean, default: null }) readonly isInner!: boolean;

    isCollapsed: boolean = this.isOpened;
    missingManager: string = "Missing Manager";
    missingContractor: string = "Missing Contractor";
    TooltipVariants = TooltipVariants;
    //create function to collapse and expand
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        this.$emit('toggleCollapse', this.isCollapsed);
    }

    showProjectDetailsModalOn(): void {
        this.$emit("showProjectDetailsModalOn");
    }

    showProjectDetailsModalOff(): void {
        this.$emit("showProjectDetailsModalOff");
    }

    mounted() {
        this.$nextTick(function () {
            let circleBottom = 0;
            let flowUp = false;
            if (document.getElementsByName(this.item.id)[0]) {
                circleBottom = document.getElementsByName(this.item.id)[0].getBoundingClientRect().bottom;
                if (circleBottom > (screen.availHeight / 2)) {
                    flowUp = true;
                } else {
                    flowUp = false;
                }
            } else {
                flowUp = false;
            }
            this.$emit("flowUp", flowUp);
        })
    }

}
